;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import { gql } from "@apollo/client"

export type GetOrganizationSubscriptionQueryVariables = {
  organizationId: string
}

export type GetOrganizationSubscriptionQueryData = {
  organizationSubscription?: {
    cancelAtPeriodEnd?: boolean | null
    id?: string | null
    items?: Array<{
      currentPeriodEnd?: string | null
      currentPeriodStart?: string | null
      id?: string | null
      price?: {
        id?: string | null
        nickname?: string | null
        unitAmount?: number | null
      } | null
      quantity?: number | null
    } | null> | null
    status?: string | null
  } | null
}

/**
 * Query to fetch organization subscription details including:
 * - Subscription status and period end
 * - Price plan details
 * - Item quantities
 */
export const GET_ORGANIZATION_SUBSCRIPTION = gql`
  query GetOrganizationSubscription($organizationId: UUID!) {
    organizationSubscription(organizationId: $organizationId) {
      cancelAtPeriodEnd
      id
      items {
        currentPeriodEnd
        currentPeriodStart
        id
        price {
          id
          nickname
          unitAmount
        }
        quantity
      }
      status
    }
  }
`
